import { Link } from 'react-router-dom';
import BackgroundSection from './BackgroundSection';
import { useTheme } from '../hooks/useTheme';
import useMediaQuery from 'hooks/useMediaQuery';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const ServicesNavigation = ({ data }) => {
  const { isDarkMode } = useTheme();
  const isMobileSize = useMediaQuery();

  return (
    <div className='page-wrapper two-image-section flex column-gap-16'>
      <Link
        to='/services/b2c'
        className={`${!isMobileSize ? 'flex-1' : ''} link-reset`}
      >
        <BackgroundSection
          imageUrl={
            isDarkMode
              ? data?.firstService?.darkModeImageUrl ||
                data?.firstService?.lightModeImageUrl
              : data?.firstService?.lightModeImageUrl
          }
          bgClassName='full-height flex flex-column justify-end flex-1'
          key='1'
          className='service-nav-links'
        >
          <p className='img-page-font-grotesk font-white-color align-self-center font-size-45 letter-spacing-4p'>
            {renderWithLineBreaks(data?.firstService?.titleGrotesk)}{' '}
            <span className='font-secondary'>
              {renderWithLineBreaks(data?.firstService?.titleItalic)}
            </span>
          </p>
        </BackgroundSection>
      </Link>
      <Link
        to='/services/b2b'
        className={`${!isMobileSize ? 'flex-1' : ''} link-reset`}
      >
        <BackgroundSection
          imageUrl={
            isDarkMode
              ? data?.secondService?.darkModeImageUrl ||
                data?.secondService?.lightModeImageUrl
              : data?.secondService?.lightModeImageUrl
          }
          bgClassName='full-height flex flex-column justify-end flex-1'
          key='2'
          className='service-nav-links'
        >
          <p className='img-page-font-grotesk font-white-color align-self-center font-size-45 letter-spacing-4p'>
            {renderWithLineBreaks(data?.secondService?.titleGrotesk)}{' '}
            <span className='font-secondary'>
              {renderWithLineBreaks(data?.secondService?.titleItalic)}
            </span>
          </p>
        </BackgroundSection>
      </Link>
    </div>
  );
};

export default ServicesNavigation;
